export default [
  {
    path: '/extrato',
    name: 'extract',
    component: () => import(/* webpackChunkName: "reports" */ './Statement.vue'),
    meta: { auth: true }
  },
]
